export default __webpack_public_path__ + "static/media/online-gp.17d09331.svg";